<template>
    <b-card @click.prevent="toggleItem($event,data.id)" :class="{'d-flex flex-row':true}" no-body>
        <div class="pl-1 d-flex flex-grow-1 min-width-zero">
            <div class="card-body hovered cursor-pointer align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                <p class="list-item-heading mb-1 truncate"> <i class="iconsminds-business-man-woman mr-1"></i> {{data.name}}</p>
                <p class="mb-1 text-muted w-15 w-sm-100"><i class="iconsminds-mail-open mr-1"></i> {{data.email}}</p>
                <p class="mb-1 text-muted text-small w-15 w-sm-100"><i class="iconsminds-id-card mr-1"></i> {{data.cin}}</p>
                <p class="mb-1 text-muted text-small w-15 w-sm-100"><i class="simple-icon-phone mr-1"></i> {{data.phone}}</p>
                <!-- <p class="mb-1 text-muted text-small w-15 w-sm-100">{{data.mituel}}</p> -->
            </div>

            <div class="custom-control custom-checkbox pl-1 align-self-center pr-4">
                <b-button :id="'reset'+data.id" @click.stop="resetPassword()" class="mb-1 mr-1" variant="warning"><i class="simple-icon-refresh"></i></b-button>
                <b-tooltip :target="'reset'+data.id"
                        :placement="'top'"
                        :title="'Reinitialiser le mot de passe'">
                </b-tooltip>
                <b-button @click.stop="editItem()" class="mb-1 mr-1" variant="primary"><i class="iconsminds-pen"></i></b-button>
                <b-button @click.stop="deleteItem()" class="mb-1" variant="danger"><i class="simple-icon-trash"></i></b-button>
            </div>
        </div>
    </b-card>
</template>
<script>
export default {
  props: ['data', 'selectedItems'],
  methods: {
    toggleItem (event, itemId) {
      this.$emit('toggle-item', event, itemId)
    },
    editItem(){
      this.$emit("edit",true)
    },
    deleteItem(){
      this.$emit("delete",true)
    },
    resetPassword(){
      this.$emit("reset",true)
    }
  }
}
</script>
